import Loadable from '../../components/loadable';

const BulkAddMembersToGradingEvent = Loadable({
  loader: () => import('../../pages/gradings/bulk_add_members_to_grading_event'),
  type: 'block',
});

angular.module('gym').value('BulkAddMembersToGradingEvent', BulkAddMembersToGradingEvent);
